// api/client.js
import axios from 'axios';

console.log(process.env.REACT_APP_API_URL)

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }

    if (originalRequest.url === '/Auth/login' || originalRequest.url === '/Auth/refresh' || originalRequest.url === '/Auth/login/forgotPassword/mfa') {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return apiClient(originalRequest);
        })
        .catch(err => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      // Hacemos la petición de refresh directamente con axios (sin usar apiClient)
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/Auth/refresh`, {}, { withCredentials: true });
      const newToken = data.accessToken; // Ajusta según la respuesta de tu backend
      localStorage.setItem('accessToken', newToken);
      //apiClient.defaults.headers.common.Authorization = `Bearer ${newToken}`;
      //originalRequest.headers.Authorization = `Bearer ${newToken}`;
      processQueue(null, newToken);
      return apiClient(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);
      localStorage.removeItem('accessToken');
      window.dispatchEvent(new Event('unauthorized')); // Para que AuthContext haga logout
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default apiClient;